var sellForm = function () {
  const progressBar = $(".js-form-progressbar");
  const formFields = $(".js-sell-form");

  $(".js-sell-button").on("click", function () {
    $(".js-sell-content").hide();
    $(".js-sell-form").show();
  });

  $(document).on(
    "click",
    ".selected-option, .selected-option + svg",
    function () {
      $(this).siblings(".select-options").toggle();
    }
  );

  $(document).on("click", ".option", function () {
    const $customSelect = $(this).closest(".custom-select");
    const value = $(this).data("value");

    $customSelect.find(".selected-option").text($(this).text());
    $customSelect.siblings("input[type='hidden']").val(value);
    $customSelect.find(".select-options").hide();
  });

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".custom-select").length) {
      $(".select-options").hide();
    }
  });

  $(".js-form-cancel").on("click", function () {
    const currentStep = parseInt(progressBar.attr("data-current"), 10);
    const prevStep = currentStep - 1;

    if (prevStep < 1) {
      $(".js-sell-form").hide();
      $(".js-sell-content").show();
      return;
    }

    progressBar.find("[data-step]").removeClass("current");
    progressBar.find(`[data-step="${prevStep}"]`).removeClass("done");
    progressBar.find(`[data-step="${prevStep}"]`).addClass("current");
    formFields.find("[data-step]").removeClass("current");
    formFields.find(`[data-step="${prevStep}"]`).addClass("current");

    if (prevStep <= 3) {
      $(
        ".js-sell-form input, .js-sell-form textarea, .js-sell-form select"
      ).removeAttr("disabled");
      $(".js-form-submit").hide();
      $(".js-form-next").show();
    }

    progressBar.attr("data-current", prevStep);
  });

  $(".js-form-next").on("click", function () {
    const currentStep = parseInt(progressBar.attr("data-current"), 10);
    const nextStep = currentStep + 1;

    if (nextStep > 4) return;

    if (currentStep == 1) {
      const productCondition = $(".js-product-condition:checked").val();
      const proofOfPurchase = $(".js-product-proof-of-purchase:checked").val();

      if (!productCondition) {
        $(".js-product-condition")
          .closest(".form-group")
          .find("> label")
          .addClass("hasError");
      } else {
        $(".js-product-condition")
          .closest(".form-group")
          .find("> label")
          .removeClass("hasError");
      }

      if (!proofOfPurchase) {
        $(".js-product-proof-of-purchase")
          .closest(".form-group")
          .find("> label")
          .addClass("hasError");
      } else {
        $(".js-product-proof-of-purchase")
          .closest(".form-group")
          .find("> label")
          .removeClass("hasError");
      }

      if (!productCondition || !proofOfPurchase) {
        $(".js-form-errors-note").show();
        return;
      } else {
        $(".js-form-errors-note").hide();
      }
    }

    if (currentStep == 2) {
      const frontImage = $("#file1")[0];
      const frontSideImage = $("#file2")[0];

      if (frontImage.files.length < 1) {
        $(".js-form-file[data-id='1'] + p").addClass("hasError");
      } else {
        $(".js-form-file[data-id='1'] + p").removeClass("hasError");
      }

      if (frontSideImage.files.length < 1) {
        $(".js-form-file[data-id='2'] + p").addClass("hasError");
      } else {
        $(".js-form-file[data-id='2'] + p").removeClass("hasError");
      }

      if (frontImage.files.length < 1 || frontSideImage.files.length < 1) {
        $(".js-form-errors-note").show();
        return;
      } else {
        $(".js-form-errors-note").hide();
      }
    }

    if (currentStep == 3) {
      const personalTitle = $(".js-personal-title").val();
      const personalTitleValidate = personalTitle != "";
      const name = $(".js-name").val();
      const email = $(".js-email").val();
      const emailPattern = new RegExp(".+@.+\\..+");
      const phoneNumber = $(".js-phone-number").val();
      const phonePattern = new RegExp("^[0-9\\-]+$");
      const emailValidate = emailPattern.test(email);
      const phoneValidate = phonePattern.test(phoneNumber);

      const terms = $(".js-terms").prop("checked");

      if (!personalTitleValidate) {
        $(".js-personal-title").closest("div.form-group").addClass("hasError");
      } else {
        $(".js-personal-title")
          .closest("div.form-group")
          .removeClass("hasError");
      }

      if (!name) {
        $(".js-name").closest("div").addClass("hasError");
      } else {
        $(".js-name").closest("div").removeClass("hasError");
      }

      if (!emailValidate) {
        $(".js-email").closest("div").addClass("hasError");
        $(".js-email + p").show();
      } else {
        $(".js-email").closest("div").removeClass("hasError");
        $(".js-email + p").hide();
      }

      if (!phoneValidate) {
        $(".js-phone-number").closest("div").addClass("hasError");
        $(".js-phone-number + p").show();
      } else {
        $(".js-phone-number").closest("div").removeClass("hasError");
        $(".js-phone-number + p").hide();
      }

      if (!terms) {
        $(".js-terms").closest("label").addClass("hasError");
      } else {
        $(".js-terms").closest("label").removeClass("hasError");
      }

      if (
        !personalTitleValidate ||
        !name ||
        !emailValidate ||
        !phoneValidate ||
        !terms
      ) {
        $(".js-form-errors-note").show();
        return;
      } else {
        $(".js-form-errors-note").hide();
      }
    }

    progressBar.find("[data-step]").removeClass("current");
    progressBar.find(`[data-step="${currentStep}"]`).addClass("done");
    progressBar.find(`[data-step="${nextStep}"]`).addClass("current");
    formFields.find("[data-step]").removeClass("current");
    if (nextStep <= 3) {
      formFields.find(`[data-step="${nextStep}"]`).addClass("current");
    } else {
      $(
        ".js-sell-form input, .js-sell-form textarea, .js-sell-form select"
      ).attr("disabled", true);
      formFields.find(`[data-step="3"]`).addClass("current");
      $(".js-form-next").hide();
      $(".js-form-submit").show();
    }

    progressBar.attr("data-current", nextStep);
    $("html, body").animate({ scrollTop: 0 }, 500);
  });

  $(".js-form-file").click(function () {
    var id = $(this).attr("data-id");
    $("#file" + id).click();
  });

  function convertHeicToJpg(input, element, id) {
    var fileName = $(input).val();
    var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
    if (fileNameExt == "heic") {
      var blob = $(input)[0].files[0];
      heic2any({
        blob: blob,
        toType: "image/jpg",
      })
        .then(function (resultBlob) {
          var url = URL.createObjectURL(resultBlob);
          $(".js-form-file[data-id='" + id + "'] img").attr("src", url);
          let fileInputElement = $(element)[0];
          let container = new DataTransfer();
          let file = new File([resultBlob], "heic" + ".jpg", {
            type: "image/jpeg",
            lastModified: new Date().getTime(),
          });
          container.items.add(file);

          fileInputElement.files = container.files;
          console.log("added");
        })
        .catch(function (x) {
          console.log(x.code);
          console.log(x.message);
        });
    }
  }

  function handleFileChange(fileInput, dataId) {
    var file_img = "";
    var file = fileInput.files[0];
    if (file) {
      if (file["name"].indexOf(".heic") != -1) {
        convertHeicToJpg(this, "#file" + dataId, dataId);
      } else {
        var filereader = new FileReader();
        filereader.readAsDataURL(file);
        filereader.onload = function (evt) {
          file_img = evt.target.result;
          $(".js-form-file[data-id='" + dataId + "'] ~ img").attr(
            "src",
            file_img
          );
          $(".js-form-file[data-id='" + dataId + "'] p")
            .eq(0)
            .html("Choose\nother file")
            .css("color", "#fff");
          $(".js-form-file[data-id='" + dataId + "'] svg").css(
            "display",
            "none"
          );
        };
      }
    }
  }

  $(".js-sell-form input[type='file']").on("change", function () {
    var dataId = $(this).attr("data-id");
    handleFileChange(this, dataId);
  });

  $(".js-form-submit").click(function () {
    if ($(".js-sell-form").hasClass("single")) {
      const productCondition = $(".js-product-condition:checked").val();
      const proofOfPurchase = $(".js-product-proof-of-purchase:checked").val();
      const frontImage = $("#file1")[0];
      const frontSideImage = $("#file2")[0];
      const personalTitle = $(".js-personal-title").val();
      const personalTitleValidate = personalTitle != "Select title";
      const name = $(".js-name").val();
      const email = $(".js-email").val();
      const emailPattern = new RegExp(".+@.+\\..+");
      const phoneNumber = $(".js-phone-number").val();
      const phonePattern = new RegExp("^[0-9\\-]+$");
      const emailValidate = emailPattern.test(email);
      const phoneValidate = phonePattern.test(phoneNumber);
      const terms = $(".js-terms").prop("checked");

      if (!productCondition) {
        $(".js-product-condition")
          .closest(".form-group")
          .find("> label")
          .addClass("hasError");
      } else {
        $(".js-product-condition")
          .closest(".form-group")
          .find("> label")
          .removeClass("hasError");
      }

      if (!proofOfPurchase) {
        $(".js-product-proof-of-purchase")
          .closest(".form-group")
          .find("> label")
          .addClass("hasError");
      } else {
        $(".js-product-proof-of-purchase")
          .closest(".form-group")
          .find("> label")
          .removeClass("hasError");
      }

      if (frontImage.files.length < 1) {
        $(".js-form-file[data-id='1'] + p").addClass("hasError");
      } else {
        $(".js-form-file[data-id='1'] + p").removeClass("hasError");
      }

      if (frontSideImage.files.length < 1) {
        $(".js-form-file[data-id='2'] + p").addClass("hasError");
      } else {
        $(".js-form-file[data-id='2'] + p").removeClass("hasError");
      }

      if (!personalTitleValidate) {
        $(".js-personal-title").closest("div.form-group").addClass("hasError");
      } else {
        $(".js-personal-title")
          .closest("div.form-group")
          .removeClass("hasError");
      }

      if (!name) {
        $(".js-name").closest("div").addClass("hasError");
      } else {
        $(".js-name").closest("div").removeClass("hasError");
      }

      if (!emailValidate) {
        $(".js-email").closest("div").addClass("hasError");
        $(".js-email + p").show();
      } else {
        $(".js-email").closest("div").removeClass("hasError");
        $(".js-email + p").hide();
      }

      if (!phoneValidate) {
        $(".js-phone-number").closest("div").addClass("hasError");
        $(".js-phone-number + p").show();
      } else {
        $(".js-phone-number").closest("div").removeClass("hasError");
        $(".js-phone-number + p").hide();
      }

      if (!terms) {
        $(".js-terms").closest("label").addClass("hasError");
      } else {
        $(".js-terms").closest("label").removeClass("hasError");
      }

      if (
        !personalTitleValidate ||
        !name ||
        !emailValidate ||
        !phoneValidate ||
        !terms ||
        frontImage.files.length < 1 ||
        frontSideImage.files.length < 1 ||
        !productCondition ||
        !proofOfPurchase
      ) {
        $(".js-form-errors-note").show();
        return;
      } else {
        $(".js-form-errors-note").hide();
      }
    }

    $(".js-contact-name").val(
      $(".js-personal-title").val() + " " + $(".js-name").val()
    );
    $(".js-contact-email").val($(".js-email").val());

    $(".js-contact-phone").val($(".js-phone-number").val());

    var message =
      "Message from build a customized sell your bag form.\n\nName: " +
      $(".js-personal-title").val() +
      " " +
      $(".js-name").val();

    message += "\n\n";
    message += "Brand: " + $(".js-product-brand:checked").val();
    message += "\n\n";
    message += "Category: " + $(".js-product-category").val();
    message += "\n\n";
    message += "Model: " + $(".js-product-model").val();
    message += "\n\n";
    message += "Material: " + $(".js-product-material").val();
    message += "\n\n";
    message += "Condition: " + $(".js-product-condition:checked").val();
    message += "\n\n";
    message +=
      "Proof of purchase: " + $(".js-product-proof-of-purchase:checked").val();
    message += "\n\n";
    message +=
      "Original box/Dust-bag: " +
      ($(".js-product-original-box:checked").length > 0
        ? $(".js-product-original-box:checked").val()
        : "");
    message += "\n\n";
    message += "Expected price: " + $(".js-product-expecting").val();
    message += "\n\n";
    message += "Product notes: " + $(".js-product-notes").val();
    message += "\n\n";
    message += "Additional info: " + $(".js-product-additional-info").val();
    message += "\n\n";

    var id = Math.floor(Math.random() * 10000000000000);
    var file1 = false;
    var file2 = false;
    var file3 = false;
    var file4 = false;
    var file5 = false;
    var file6 = false;

    var file = document.getElementById("file1").files[0];
    if (file) {
      var img = document.createElement("img");
      img.src = window.URL.createObjectURL(
        document.getElementById("file1").files[0]
      );
      img.onload = function () {
        var canvas = $("#canvaFile1").get(0);
        var MAX_WIDTH = 1000;
        var MAX_HEIGHT = 1000;
        var width = img.width;
        var height = img.height;
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        file1 = canvas.toDataURL("image/png");
      };
    }
    var file = document.getElementById("file2").files[0];
    if (file) {
      var img2 = document.createElement("img");
      img2.src = window.URL.createObjectURL(
        document.getElementById("file2").files[0]
      );
      img2.onload = function () {
        var canvas = $("#canvaFile2").get(0);
        var MAX_WIDTH = 1000;
        var MAX_HEIGHT = 1000;
        var width = img2.width;
        var height = img2.height;
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img2, 0, 0, width, height);
        file2 = canvas.toDataURL("image/png");
      };
    }
    var file = document.getElementById("file3").files[0];
    if (file) {
      var img3 = document.createElement("img");
      img3.src = window.URL.createObjectURL(
        document.getElementById("file3").files[0]
      );
      img3.onload = function () {
        var canvas = $("#canvaFile3").get(0);
        var MAX_WIDTH = 1000;
        var MAX_HEIGHT = 1000;
        var width = img3.width;
        var height = img3.height;
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img3, 0, 0, width, height);
        file3 = canvas.toDataURL("image/png");
      };
    }
    var file = document.getElementById("file4").files[0];
    if (file) {
      var img4 = document.createElement("img");
      img4.src = window.URL.createObjectURL(
        document.getElementById("file4").files[0]
      );
      img4.onload = function () {
        var canvas = $("#canvaFile4").get(0);
        var MAX_WIDTH = 1000;
        var MAX_HEIGHT = 1000;
        var width = img4.width;
        var height = img4.height;
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img4, 0, 0, width, height);
        file4 = canvas.toDataURL("image/png");
      };
    }
    var file = document.getElementById("file5").files[0];
    if (file) {
      var img5 = document.createElement("img");
      img5.src = window.URL.createObjectURL(
        document.getElementById("file5").files[0]
      );
      img5.onload = function () {
        var canvas = $("#canvaFile5").get(0);
        var MAX_WIDTH = 1000;
        var MAX_HEIGHT = 1000;
        var width = img5.width;
        var height = img5.height;
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img5, 0, 0, width, height);
        file5 = canvas.toDataURL("image/png");
      };
    }
    var file = document.getElementById("file6").files[0];
    if (file) {
      var img6 = document.createElement("img");
      img6.src = window.URL.createObjectURL(
        document.getElementById("file6").files[0]
      );
      img6.onload = function () {
        var canvas = $("#canvaFile6").get(0);
        var MAX_WIDTH = 1000;
        var MAX_HEIGHT = 1000;
        var width = img6.width;
        var height = img6.height;
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img6, 0, 0, width, height);
        file6 = canvas.toDataURL("image/png");
      };
    }

    setTimeout(function () {
      $.post(
        "https://dashcreativeshopifyscripts.co/bagista/sell_your_bag/index.php",
        {
          id: id,
          file1: file1,
          file2: file2,
          file3: file3,
          file4: file4,
          file5: file5,
          file6: file6,
        },
        function (response) {}
      );
    }, 7500);
    message += "Uploaded images:\n";
    var file = document.getElementById("file1").files[0];
    if (file) {
      message +=
        "Front: " +
        "https://dashcreativeshopifyscripts.co/bagista/sell_your_bag/images/" +
        id +
        "_front.png\n";
    } else {
      message += "Front: NO IMAGE\n";
    }
    var file = document.getElementById("file2").files[0];
    if (file) {
      message +=
        "Front-side: " +
        "https://dashcreativeshopifyscripts.co/bagista/sell_your_bag/images/" +
        id +
        "_front_side.png\n";
    } else {
      message += "Front-side: NO IMAGE\n";
    }
    var file = document.getElementById("file3").files[0];
    if (file) {
      message +=
        "Side: " +
        "https://dashcreativeshopifyscripts.co/bagista/sell_your_bag/images/" +
        id +
        "_side.png\n";
    } else {
      message += "Side: NO IMAGE\n";
    }
    var file = document.getElementById("file4").files[0];
    if (file) {
      message +=
        "Back: " +
        "https://dashcreativeshopifyscripts.co/bagista/sell_your_bag/images/" +
        id +
        "_back.png\n";
    } else {
      message += "Back: NO IMAGE\n";
    }
    var file = document.getElementById("file5").files[0];
    if (file) {
      message +=
        "Bottom: " +
        "https://dashcreativeshopifyscripts.co/bagista/sell_your_bag/images/" +
        id +
        "_bottom.png\n";
    } else {
      message += "Bottom: NO IMAGE\n";
    }
    var file = document.getElementById("file6").files[0];
    if (file) {
      message +=
        "Interior: " +
        "https://dashcreativeshopifyscripts.co/bagista/sell_your_bag/images/" +
        id +
        "_interior.png\n";
    } else {
      message += "Interior: NO IMAGE\n";
    }
    message += "\n";

    $(".js-ask-question-body").val(message);
    console.log(message);

    $(".js-form-submit").html("Sending...");
    setTimeout(function () {
      $("#SellForm").submit();
    }, 30000);
    $(".js-uploading-note").show();
    var i = 30;
    $(".js-form-submit").html("Sending... (30s)");
    setInterval(function () {
      i--;
      if (i >= 0) {
        $(".js-form-submit").html("Sending... (" + i + "s)");
      }
    }, 1000);

    return false;
  });
};

sellForm();
